// BASE url
// https://productreviews.shopifycdn.com/proxy/v4/reviews/product?callback=reviewLoaded&shop=lsg-fitness.myshopify.com&product_id=1220872470585
// BADGE
// https://productreviews.shopifycdn.com/proxy/v4/reviews/badges?callback=Log&shop=lsg-fitness.myshopify.com&product_ids[]=1221286330425&product_ids[]=1220872470585&product_ids[]=1599523356729&product_ids[]=1220871684153&product_ids[]=1221286494265&_=1538922899691
var idp = $('#product-reviews').attr('idp');
$(document).ready(function() {
    $(function () {
        $.ajax({
            "url": "https://productreviews.shopifycdn.com/proxy/v4/reviews/product?callback=productCallback6628202021045&product_id="+idp+"&version=v4&shop=lsg-fitness.myshopify.com",
            "type": "get",
            "dataType": "jsonp",
            jsonpCallback: "productCallback6628202021045"
        })
        .done(function (data) {
            //console.log(data)
            if (data.aggregate_rating) {
                var rating = data.aggregate_rating.replace('<script type="application/ld+json">', '');
                rating = rating.replace('</script>', '');
                rating = JSON.parse(rating);
                $('.review-average').text(round(rating.ratingValue));
                $('.review-number').text(rating.reviewCount+' Reviews |');
                $('.review-number-customer').text('Reviewed by '+rating.reviewCount+' Customers')
                parseReview(data.reviews);
                addPagination(data.reviews, Math.round(rating.reviewCount/5));
            } else {
                $('.hide-when-no-review').remove();
                $('.spr-form').css('margin-top', '0');
            }
        })
        .fail(function(jqXHR, status, error) {
            console.log(error);
        })
    });
    $('.write-review').on( "click", function() {
        $('html, body').animate({
            scrollTop: $('#spr-form').offset().top
        }, 500);
    })
    // Call Next pagination review data
    $( "#spr-pagination" ).on( "click", '.spr-pagination-page', function() {
    	var target = "#product-reviews";
    	$(target).addClass('load');
    	$('html, body').animate({
            scrollTop: $(target).offset().top
        }, 500);
        $('.spinner-1').show();

    	$("#spr-pagination span").removeClass('active');
    	$(this).addClass('active');
      	var page = $(this).text();
      	$(function () {
      	  $.ajax({
      	    "url": "https://productreviews.shopifycdn.com/proxy/v4/reviews?callback=logResult&page="+page+"&product_id="+idp+"&shop=lsg-fitness.myshopify.com",
      	    "type": "get",
      	    "dataType": "jsonp",
      	    jsonpCallback: "logResults"
      	  })
      	  .done(function (data) {
      	  	$('#multipleReviews').html("");
      	  	parseReview(data.reviews);
      	  	$('.spinner-1').hide();
      	  	$(target).removeClass('load');
      	  })
      	  .fail(function(jqXHR, status, error) {
      		console.log(error);
      	  })
      	});
    });
})


function addPagination(data, paginateNumber){
    if (paginateNumber > 1) {
        $('#spr-pagination').append("<span data-page='1' class='spr-pagination-page active'>1</span>");
        for (var h = 2; h <= paginateNumber; h++) {
          $('#spr-pagination').append("<span data-page='"+h+"' class='spr-pagination-page'>"+h+"</span>");
        }
    } else {
        $('#spr-pagination').hide()
    }
}

function parseReview(data) {
    var el = document.createElement( 'html' );
    el.innerHTML = '<html><head><title>titleTest</title></head><body>'+data+'</body></html>';

    //DISPLAY REVIW
    // 0: <div class="spr-review-header">
    // 1: <div class="spr-review-content">
    // 2: <div class="spr-review-reply">
    // 3: <div class="spr-review-footer">
    var reviewAll = $('div.spr-review', el);
    // console.log(reviewAll);
    var i;
    for (i = 0; i < reviewAll.length; i++) {

        $('#multipleReviews').append("<div class='spr-review clearfix review_"+i+"'></div>");
        var h1 = "<div class='spr-review-header-byline'>"+reviewAll[i].children[0].children[2].innerHTML+"</div>";
        var h2 = "<div class='spr-starratings spr-review-header-starratings'>"+reviewAll[i].children[0].children[0].innerHTML+"</div>";
        var reviewsHead = h1+""+h2;

        var reviewsTtl = "<h3 class='spr-review-header-title'>"+reviewAll[i].children[0].children[1].innerHTML+"</h3>";
        var reviewsText = reviewAll[i].children[1].innerHTML;
        var findWeb = reviewsText;
        var findWhat = /\[[^]*\]/gm;
        var finalReviewText = findWeb;
        var webSource = '';
        if (findWeb.match(findWhat)) {
            var webIs = findWhat.exec(findWeb);
            var file_image = webIs[0].replace('[', '');
            file_image = file_image.replace(']', '');
            file_image = file_image.replace(' ', '_');
            file_image = "https://cdn.shopify.com/s/files/1/0105/0918/9177/files/Logo-"+file_image+".png";
            webSource = "<div class='review-src'><span>Reviewed on</span><img src='"+file_image+"'>";
            finalReviewText = findWeb.replace(webIs[0], "");
        }
        // AS REPORT ALWAYS IN THE LAST
        var reportIndex = reviewAll[i].children.length -1;
        var reportReview = reviewAll[i].children[reportIndex].innerHTML.replace('Report as Inappropriate', 'Flag this Review');

        $('.review_'+i).append("<div class='spr-review-header'>"+reviewsHead+""+webSource+"</div>");
        $('.review_'+i).append("<div class='spr-review-content'>"+reviewsTtl+""+finalReviewText+"</div>");
        $('.review_'+i).append("<div class='spr-review-footer'>"+reportReview+"</div>");
        //console.log(reviewAll[i].children[1].innerHTML);
    } 
}


function round(number){
  var numString = number.toString();
  var returnNumb= number;
  if (numString.length > 2) {
    if (parseInt(numString[3]) >= 5) {
      var newValue = parseInt(numString[2])+1;
      returnNumb = numString.substring(0, 2)+''+newValue;
    } else {
      returnNumb = numString.substring(0, 3);
    }
  }
  return returnNumb; 
}
